<template>
  <NavigationSiteHeader />
  <SessionExpiration />
  <v-main>
    <router-view />
  </v-main>
  <NavigationSiteFooter />
</template>
